import { z } from 'zod';
import { SocialAccountType } from '@anytag/graphql';
import { SearchSchema } from '@anytag/shared-validations';
import { EngagementPostsFilterSchema } from '@anytag/shared-organisms';

export const EggPostSearchSchema = SearchSchema.create({
  filter: {
    schema: z
      .object({
        id: SearchSchema.types.number(),
        name: SearchSchema.types.string(),
        socialAccountId: SearchSchema.types.number(),
        socialAccountName: SearchSchema.types.string(),
        socialAccountMedia: SearchSchema.types.enum(SocialAccountType)
      })
      .merge(EngagementPostsFilterSchema)
  }
});

export type EggPostSearchSchemaType = z.infer<typeof EggPostSearchSchema>;
